import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Star = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m42.49 16.252-14.088-.595-4.92-13.218A1.574 1.574 0 0 0 22 1.419c-.661 0-1.243.398-1.482 1.02l-4.92 13.218-14.088.595c-.661.027-1.23.45-1.429 1.085-.211.635 0 1.31.516 1.72l11.046 8.773-3.784 13.588a1.54 1.54 0 0 0 .596 1.694 1.55 1.55 0 0 0 1.799.04L22 35.345l11.746 7.807c.265.172.57.264.873.264.318 0 .649-.106.926-.304a1.568 1.568 0 0 0 .596-1.694L32.358 27.83l11.045-8.773c.516-.41.727-1.085.516-1.72a1.577 1.577 0 0 0-1.429-1.085ZM30.902 26.44a1.561 1.561 0 0 0-.542 1.654l3.572 12.795-11.059-7.343a1.556 1.556 0 0 0-1.746 0l-11.059 7.343 3.559-12.795a1.554 1.554 0 0 0-.543-1.654L2.687 18.184l13.268-.556a1.577 1.577 0 0 0 1.415-1.018L22 4.159l4.63 12.45c.225.596.78.993 1.415 1.02l13.268.555-10.41 8.256Z"
  }));
});
Star.displayName = 'Star';
Star.defaultProps = {
  'aria-label': 'Star'
};
export default Star;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Star.js
// module id = 3292
// module chunks = 11